import type { Params } from 'react-router-dom'

import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import moment from 'moment'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import View, {
  DEFAULT_GROUP_TYPE,
  DEFAULT_VIEW_TYPE,
  type GroupType,
  type ViewType,
  isValidGroupType,
  isValidViewType,
} from 'modules/shift_management/store/internal/models/View'

import useIsTimeFormat24H from '../hooks/useIsTimeFormat24H'

type ParamProps = Readonly<Params<string>>
type ViewTypes = ViewType
type GroupTypes = GroupType

export const useCustomViewGroupPath = (params: ParamProps) => {
  const { navigation } = useNavigation()

  const { year, month, day, viewType: viewTypeParams, groupType: groupTypeParams } = params
  const dateFromParams = moment([Number(year), Number(month) - 1, Number(day)])
  const date = dateFromParams.isValid() ? dateFromParams : moment()

  const localStorageKey = LOCAL_STORAGE_KEYS.shiftManagementView
  const [localStorage] = useLocalStorage<string>(localStorageKey)
  const localStorageViewType = localStorage?.split('/')[0]
  const localStorageGroupType = localStorage?.split('/')[1]

  const viewType: ViewType = isValidViewType(viewTypeParams)
    ? viewTypeParams
    : isValidViewType(localStorageViewType)
    ? localStorageViewType
    : DEFAULT_VIEW_TYPE

  const groupType: GroupType = isValidGroupType(groupTypeParams)
    ? groupTypeParams
    : isValidGroupType(localStorageGroupType)
    ? localStorageGroupType
    : DEFAULT_GROUP_TYPE

  const { isTimeFormat24H } = useIsTimeFormat24H()

  const view = new View({
    date,
    viewType: viewType,
    groupType: groupType,
    isTimeFormat24H,
  })

  return navigation.shifts.customViewGroup.fullPath({
    viewType: view.viewType,
    groupType: view.groupType,
    year: view.startRangeYear,
    month: view.startRangeMonth,
    day: view.startRangeDay,
  })
}
